module.exports = __webpack_public_path__ + "img/task-note.4dc62e2c.svg";